import { render, staticRenderFns } from "./BlockLogos.vue?vue&type=template&id=36ea6092&scoped=true"
import script from "./BlockLogos.vue?vue&type=script&lang=js"
export * from "./BlockLogos.vue?vue&type=script&lang=js"
import style0 from "./BlockLogos.vue?vue&type=style&index=0&id=36ea6092&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea6092",
  null
  
)

export default component.exports